"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _offset = require("./offset");

var _offset2 = _interopRequireDefault(_offset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentPosition = function () {
    function DocumentPosition(index, offset) {
        (0, _classCallCheck3.default)(this, DocumentPosition);

        this._index = index;
        this._offset = offset;
    }

    (0, _createClass3.default)(DocumentPosition, [{
        key: "compare",
        value: function compare(otherPos) {
            if (this._index === otherPos._index) {
                return this._offset - otherPos._offset;
            } else {
                return this._index - otherPos._index;
            }
        }
    }, {
        key: "iteratePartsBetween",
        value: function iteratePartsBetween(other, model, callback) {
            if (this.index === -1 || other.index === -1) {
                return;
            }

            var _ref = this.compare(other) < 0 ? [this, other] : [other, this],
                _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                startPos = _ref2[0],
                endPos = _ref2[1];

            if (startPos.index === endPos.index) {
                callback(model.parts[this.index], startPos.offset, endPos.offset);
            } else {
                var firstPart = model.parts[startPos.index];
                callback(firstPart, startPos.offset, firstPart.text.length);
                for (var i = startPos.index + 1; i < endPos.index; ++i) {
                    var part = model.parts[i];
                    callback(part, 0, part.text.length);
                }
                var lastPart = model.parts[endPos.index];
                callback(lastPart, 0, endPos.offset);
            }
        }
    }, {
        key: "forwardsWhile",
        value: function forwardsWhile(model, predicate) {
            if (this.index === -1) {
                return this;
            }

            var index = this.index,
                offset = this.offset;
            var parts = model.parts;

            while (index < parts.length) {
                var part = parts[index];
                while (offset < part.text.length) {
                    if (!predicate(index, offset, part)) {
                        return new DocumentPosition(index, offset);
                    }
                    offset += 1;
                }
                // end reached
                if (index === parts.length - 1) {
                    return new DocumentPosition(index, offset);
                } else {
                    index += 1;
                    offset = 0;
                }
            }
        }
    }, {
        key: "backwardsWhile",
        value: function backwardsWhile(model, predicate) {
            if (this.index === -1) {
                return this;
            }

            var index = this.index,
                offset = this.offset;

            var parts = model.parts;
            while (index >= 0) {
                var part = parts[index];
                while (offset > 0) {
                    if (!predicate(index, offset - 1, part)) {
                        return new DocumentPosition(index, offset);
                    }
                    offset -= 1;
                }
                // start reached
                if (index === 0) {
                    return new DocumentPosition(index, offset);
                } else {
                    index -= 1;
                    offset = parts[index].text.length;
                }
            }
        }
    }, {
        key: "asOffset",
        value: function asOffset(model) {
            if (this.index === -1) {
                return new _offset2.default(0, true);
            }
            var offset = 0;
            for (var i = 0; i < this.index; ++i) {
                offset += model.parts[i].text.length;
            }
            offset += this.offset;
            var lastPart = model.parts[this.index];
            var atEnd = offset >= lastPart.text.length;
            return new _offset2.default(offset, atEnd);
        }
    }, {
        key: "isAtEnd",
        value: function isAtEnd(model) {
            if (model.parts.length === 0) {
                return true;
            }
            var lastPartIdx = model.parts.length - 1;
            var lastPart = model.parts[lastPartIdx];
            return this.index === lastPartIdx && this.offset === lastPart.text.length;
        }
    }, {
        key: "isAtStart",
        value: function isAtStart() {
            return this.index === 0 && this.offset === 0;
        }
    }, {
        key: "index",
        get: function get() {
            return this._index;
        }
    }, {
        key: "offset",
        get: function get() {
            return this._offset;
        }
    }]);
    return DocumentPosition;
}(); /*
     Copyright 2019 The Matrix.org Foundation C.I.C.
     
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
     
         http://www.apache.org/licenses/LICENSE-2.0
     
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */

exports.default = DocumentPosition;
module.exports = exports["default"];
//# sourceMappingURL=position.js.map